<template>
  <!-- 工单 -->
  <div class="active_table">
    <toolbar>
      <div class="search">
        <div class="label">选择站点：</div>
        <Select v-model="search.siteMn" style="width: 7.8em" placeholder="选择站点" clearable>
          <Option v-for="item in siteList" :value="item.mn" :key="item.mn">{{ item.name }}</Option>
        </Select>
        <div class="label" style="margin-left: 10px;">工单等级：</div>
        <Select v-model="search.urgencyLevel" style="width: 7.8em;" placeholder="选择类型" clearable>
          <Option v-for="item in urgencyLevelList" :value="item.value" :key="item.name">{{ item.name }}</Option>
        </Select>
        <div class="label" style="margin-left: 10px;">巡检时间：</div>
        <DatePicker type="daterange" placement="bottom-end" placeholder="选择日期" style="width: 200px;"
          @on-change="dateSelect($event)"></DatePicker>
        <i-button type="default" @click="getData" style="margin-left: 1em;">筛选</i-button>
        <!-- <i-button type="default" @click="$refs.workFlowRef.open()" style="margin-left: 1em;">测试按钮</i-button> -->
      </div>
    </toolbar>
    <div class="table">
      <i-table border :columns="table.columns" :data="table.data"></i-table>
      <Page :total="table.total" show-sizer @on-change="pageCurrentChange($event)"
        @on-page-size-change="pageSizeChange($event)" style="text-align:right;margin-top: 1em" />
      <Spin fix v-show="table.loading"></Spin>
    </div>

    <!-- 图片预览 -->
    <Modal title="图片展示" v-model="publicImgShow" :mask-closable="false">
      <swiper :options="swiperOption">
        <swiper-slide v-for="items in publicImg" :key="items">
          <img :src="items" style="width: 100%;" alt="">
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
      <div slot="footer"></div>
    </Modal>

    <!-- 工单详情 -->
    <Modal title="工单详情" v-model="workDetailsShow" :mask-closable="false">
      <div class="details_content">
        <div class="f_header">
          工单信息
        </div>
        <div class="f_content">
          <ul>
            <li>
              设备名称：{{ workDetails.inspectionDevice.deviceName }}
            </li>
            <li>
              产生日期：{{ workDetails.inspectionDevice.createDate }}
            </li>
            <li>
              问题原因：{{ workDetails.inspectionDevice.remark }}
            </li>
          </ul>
          <div class="img_list" style="display: flex;">
            <div class="img_item" style="margin-right: 10px;" v-for="item in workDetails.inspectionDevice.imgUrlList"
              :key="item">
              <img :src="item" style="width: 20%;" alt="">
            </div>
          </div>
        </div>

        <div class="complete_header" v-if="workDetails.status == 0">
          还未解决
        </div>
        <div class="complete_header" v-if="workDetails.status == 1">
          完成信息
        </div>
        <div class="complete_content">
          <ul>
            <li>
              维修人：{{ workDetails.executorUserName }}
            </li>
            <li>
              维修日期：{{ workDetails.updateDate }}
            </li>
            <li>
              备注：{{ workDetails.remark }}
            </li>
          </ul>
          <div class="img_list" style="display: flex;">
            <div class="img_item" style="margin-right: 10px;" v-for="item in workDetails.imgUrlList" :key="item">
              <img :src="item" style="width: 20%;" alt="">
            </div>
          </div>
        </div>
      </div>
      <div slot="footer"></div>
      <workFlowDialog ref="workFlowRef" @success="getData"></workFlowDialog>
    </Modal>
  </div>
</template>

<style lang="scss" scoped>
.active_table {
  width: 100%;
  height: 100%;
}

.table {
  padding: 0 1em;
  width: 100%;
  height: calc(100% - 7.5em);
  position: relative;
}

.content {
  width: 700px;

  img {
    width: 100%;
  }
}

.details_content {
  font-size: 14px;

  .f_header {
    font-weight: 700;
  }

  .complete_header {
    font-weight: 700;
  }
}
</style>

<script>
import toolbar from "../toolBar.vue";
import { timeStamp } from "../../../util/common/date";
import workFlowDialog from "./workFlowDialog.vue";
import { urgencyLevelMap } from "./dict";

export default {
  data() {
    return {
      urgencyLevelMap: urgencyLevelMap,
      // 表格
      table: {
        // 表格属性
        columns: [
          {
            type: "selection",
            width: 60,
            align: "center"
          },
          {
            title: "序号",
            key: "index",
            width: 80,
            align: "center"
          },
          {
            title: "站点名称",
            key: "siteName",
            align: "center"
          },
          // {
          //   title: "现场照片",
          //   key: "active",
          //   align: "center",
          //   render: (h, params) => {
          //     return h("div", [
          //       h(
          //         "i-button",
          //         {
          //           props: {
          //             type: "info",
          //             size: "small"
          //           },
          //           style: {},
          //           on: {
          //             click: () => {
          //               this.publicImg = params.row.imgurl.split(",");
          //               this.publicImgShow = true;
          //             }
          //           }
          //         },
          //         "点击预览"
          //       )
          //     ]);
          //   }
          // },
          // {
          //   title: "备注",
          //   key: "remark",
          //   align: "center"
          // },
          {
            title: "工单日期",
            key: "createDate",
            width: 180,
            align: "center",
            render: (h, params) => {
              return h("div", [
                h("span", {}, timeStamp(params.row.createDate))
              ]);
            }
          },
          {
            title: "紧急级别",
            key: "urgencyLevel",
            align: "center",
            render: (h, params) => {
              return h("div", [
                h("span", {
                  style: {
                    color: "#fff",
                    ...this.getColor(params.row),
                    "border-radius": "12px",
                    height: "24px",
                    padding: "0 10px"
                  }
                }, this.urgencyLevelMap[params.row.urgencyLevel] || "暂无")
              ])
            }
          },
          {
            title: "状态",
            key: "statusName",
            align: "center",
            // render: (h, params) => {
            //   return h("div", [
            //     h("span", {}, params.row.status ? "已完成" : "未完成")
            //   ]);
            // }
          },
          {
            title: "操作",
            align: "center",
            width: 80,
            render: (h, params) => {
              return h("div", [
                h(
                  "i-button",
                  {
                    props: {
                      type: "info",
                      size: "small"
                    },
                    on: {
                      click: () => {
                        // this.workDetails = params.row;
                        // this.workDetails.updateDate = timeStamp(this.workDetails.updateDate);
                        // this.workDetails.inspectionDevice.createDate = timeStamp(this.workDetails.inspectionDevice.createDate);
                        // this.workDetailsShow = true;
                        this.$refs.workFlowRef.open(params.row)
                      }
                    }
                  },
                  "详情"
                )
              ]);
            }
          }
        ],
        data: [],
        pageCurrent: 1,
        pageSize: 10,

        total: 0,
        loading: true,
        isSystem_loading: false // 切换启用状态loading
      },
      // 查询
      search: {
        siteMn: null, // 站点MN
        startDate: null,
        endDate: null,
        urgencyLevel: null // 告警级别
      },
      // 枚举数据
      siteList: [], // 站点枚举列表
      urgencyLevelList: [
        { value: null, name: '全部记录' },
        { value: 1, name: '异常记录' },
      ], //告警级别，
      workDetailsShow: false, // 工单详情modal开关
      workDetails: {
        inspectionDevice: {}
      },      // 工单详情
      publicImgShow: false,  // 图片显示器
      publicImg: [],
      swiperOption: {
        pagination: '.swiper-pagination',
        paginationClickable: true,
        autoplay: 2500,
        autoplayDisableOnInteraction: false,
        loop: false,
        coverflow: {
          rotate: 30,
          stretch: 10,
          depth: 60,
          modifier: 2,
          slideShadows: true
        }
      }
    };
  },
  components: {
    toolbar,
    workFlowDialog
  },
  created() {
    this.search.siteMn = this.$route.query.siteMn;
    this.getData(); // 数据初始化
    this.getSiteEnum();
  },
  methods: {
    getColor(row) {
      if (row.urgencyLevel == "0") {
        return {
          "background-image": "linear-gradient(118deg, #52F593 0%, #00BE1B 100%)"
        }
      } else if (row.urgencyLevel == "1") {
        return {
          "background-image": "linear-gradient(-82deg, #FF8100 25%, #FFB83A 100%)"
        }
      } else if (row.urgencyLevel == "2") {
        return {
          "background-image": "linear-gradient(-80deg, #FF0037 0%, #FF7357 100%)"
        }
      }
    },
    getData() {
      // 获取数据
      this.table.loading = true;
      this.$api.Event.getWorkList(
        {
          pageCurrent: this.table.pageCurrent,
          pageSize: this.table.pageSize,
          content: this.search
        },
        ["uuid", "company"]
      ).then(res => {
        if (res.code == 0) {
          // 获取成功
          // 给list数组中的每个元素添加index索引字段
          res.data.list.forEach((item, index) => {
            item.index = index + 1;
          });
          this.table.data = res.data.list;
          this.table.total = res.data.total;
          this.table.loading = false;
          this.$Message.success("加载完成");
        } else {
          this.$Message.warning(res.message);
          this.table.loading = false;
        }
      });
    },

    pageCurrentChange(num) {
      // 页码跳转
      this.table.pageCurrent = num;
      this.getData();
    },
    pageSizeChange(num) {
      // 每页数量切换
      this.table.pageSize = num;
      this.getData();
    },
    // 获取站点枚举值
    getSiteEnum() {
      this.$api.Enum.getSiteEnum(null, ["uuid", "company"]).then(res => {
        if (res.code == 0) {
          this.siteList = res.data;
        } else {
          this.$Notice.warning({
            title: "获取站点枚举失败",
            desc: res.message || "请联系管理员"
          });
        }
      });
    },
    dateSelect(date) {
      this.search.startDate = new Date(date[0]).setHours(0, 0, 0, 0);
      this.search.endDate = new Date(date[1]).setHours(23, 59, 59, 999);
    },
  }
};
</script>